
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund",
      function () {
        return require("private-next-pages/refund.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund"])
      });
    }
  